const envName = process.env.NEXT_PUBLIC_ENV_NAME || 'prd';

export const apiGateway = {
  host: `https://${envName}-api-sc.aberdeencloud01.com`,
  path: '/api',
  proxyPath: '/api/gateway',
};
